import React from 'react';
import { Box, Button } from '@wix/design-system';
import { observer } from 'mobx-react-lite';
import { Add } from '@wix/wix-ui-icons-common';
import { CustomFieldsWidgetState } from '../../state';
import { withoutDefaults } from '@wix/bex-core';
import { ManageFieldsCTAButton } from '../CustomFieldsPanel/ManageFieldsCTAButton';
import { cairoDataExAddCustomField } from '@wix/bex-core/bi';
import { CustomFieldsDisabledTooltip } from '../CustomFields';

export interface CustomFieldsWidgetActionsProps {
  state: CustomFieldsWidgetState;
}

const _ActionButtons = ({ state }: CustomFieldsWidgetActionsProps) => {
  const {
    container: { translate: t },
  } = state;

  return (
    <Box gap="SP2">
      <CustomFieldsDisabledTooltip
        disabled={state.dataExtension.disableAddCustomField}
        content={state.dataExtension.disableAddCustomFieldContent}
      >
        <Button
          dataHook="add-custom-field-btn"
          prefixIcon={<Add />}
          size="small"
          priority="secondary"
          onClick={() => {
            const origin = 'Custom fields widget';
            state.reportBi(
              withoutDefaults(cairoDataExAddCustomField)({
                origin,
              }),
            );
            state.dataExtension.openCustomFieldModal({ origin });
          }}
        >
          {t('cairo.customFields.addCustomField.CTA')}
        </Button>
      </CustomFieldsDisabledTooltip>
      <ManageFieldsCTAButton state={state} origin="Custom fields widget" />
    </Box>
  );
};

export const ActionButtons = observer(_ActionButtons);
